"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scale = exports.StudentClass = void 0;
const common_1 = require("./common");
exports.StudentClass = {
  Undergraduate: 'Undergraduate',
  Postgraduate: 'Postgraduate',
  Masters: 'Masters',
  PhD: 'PhD'
};
exports.Scale = common_1.Scale.Single;